import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"

const useStyles = makeStyles(theme => ({
	container: {
		marginTop: "16px"
	},
	triggerDescriptionContainer: {
		paddingLeft: theme.spacing(2),
		flex: 1
	},
	title: {
		fontSize: "12px",
		fontStyle: "normal",
		fontWeight: 500,
		lineHeight: "24px",
		color: colors.gray[300]
	},
	syncTags: {
		borderStyle: "solid",
		borderWidth: "1px",
		borderColor: colors.gray[100],
		borderRadius: "4px"
	},
	syncTagsIcon: {
		color: colors.getPrimaryColor(),
		fontSize: "32px",
		transform: "rotate(90deg)"
	},
	startSyncTagsIconAnimation: {
		animationName: "$syncTagsIconLoading",
		animationDuration: "1s",
		animationIterationCount: "infinite"
	},
	"@keyframes syncTagsIconLoading": {
		from: {
			transform: "rotate(90deg)"
		},
		to: {
			transform: "rotate(-90deg)"
		}
	},
	tagChip: {
		borderRadius: "4px !important",
		display: "inline-flex !important"
	},
	iconButton: {
		width: "19px",
		height: "19px"
	}
}))

export default useStyles
